import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, ModalFooter, Row } from 'reactstrap';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../../common/Table';
import { MANIFEST_CARGO_ITEM_COLUMNS } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';

const UnloadCargoFromItineraryModal = ({
  items,
  onClickConfirm,
  onClickCancel,
  loading,
}) => {
  const itemsToUnload = items.filter((item) => item.arrived);
  const itemsToKeep = items.filter((item) => !item.arrived);

  return (
    <>
      <p className="text-muted">
        Una vez confirmada la operación, las encomiendas seleccionadas serán
        marcadas como descargadas, mientras que las demás serán marcadas como
        perdidas.
      </p>
      <Row className="mb-4">
        <Col>
          <h4 className="text-center">Encomiendas a descargar</h4>
          <Table
            columns={MANIFEST_CARGO_ITEM_COLUMNS}
            data={itemsToUnload.toJS()}
            manual={false}
            filterable
            defaultFilterMethod={filterMethodCaseInsensitive}
          />
        </Col>
        <Col>
          <h4 className="text-center">Encomiendas Perdidas</h4>
          <Table
            columns={MANIFEST_CARGO_ITEM_COLUMNS}
            data={itemsToKeep.toJS()}
            manual={false}
            filterable
            defaultFilterMethod={filterMethodCaseInsensitive}
          />
        </Col>
      </Row>

      <ModalFooter>
        <Button color="secondary" onClick={onClickCancel} disabled={loading}>
          Cancelar
        </Button>
        <Button color="success" onClick={onClickConfirm} disabled={loading}>
          Confirmar
        </Button>
      </ModalFooter>
    </>
  );
};

UnloadCargoFromItineraryModal.propTypes = {
  items: PropTypes.instanceOf(Immutable.List).isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  onClickCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ CargoUnit }) => ({
  loading: !CargoUnit.ItemToItinerary.getIn(['current', 'activity']).isEmpty(),
});

export default connect(mapStateToProps, null)(UnloadCargoFromItineraryModal);
